export const GET_FAQ_LOADING = "GET_FAQ_LOADING";
export const GET_FAQ_SUCCESS = "GET_FAQ_SUCCESS";
export const GET_FAQ_FAILURE = "GET_FAQ_FAILURE";
